<template>
  <b-modal
    id="reject-retailer-modal-doorder"
    modal-class="modal-doorder"
    hide-footer
    centered
    body-class="text-center"
    ><b-form @submit.prevent="onSubmitReject">
      <b-row class="mt-3">
        <b-col lg="4" md="5" class="mx-auto">
          <img src="@/assets/images/doorder/reject-img.png" alt="Reqject" />
          <h2 class="modal-subtitle">Rejected</h2>
        </b-col>
      </b-row>
      <b-row class="mt-2 mb-3">
        <b-col lg="10" md="10" class="mx-auto">
          <b-form-group
            label="Please add reason for rejection"
            label-for="rejection_reason"
            label-class="form-label-doorder"
            class="h-100 form-group-textarea-doorder"
          >
            <b-form-textarea
              id="rejection_reason"
              class="form-control-doorder"
              v-model="rejection_reason"
              :name="rejection_reason"
              rows="4"
              required
              >{{ rejection_reason }}</b-form-textarea
            >
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center w-100">
        <b-col lg="3" md="6" class="text-center">
          <b-button
            v-if="!is_loading"
            type="submit"
            variant="doorder-primary"
            class="btn-bumblebee btn-doorder btn-doorder-submit w-100"
          >
            Send
          </b-button>
          <b-button
            type="button"
            disabled
            variant="doorder-primary"
            class="btn-bumblebee btn-doorder w-100 mb-1"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading</b-button
          >
        </b-col>

        <b-col lg="3" md="6" class="text-center">
          <b-button
            type="button"
            variant="doorder-danger-outline"
            class="btn-bumblebee btn-doorder btn-doorder-submit w-100"
            @click="closeModal"
          >
            Close
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>


<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "RejectRetailerModal",
  props: ["retailer_id"],
  data() {
    return {
      client_name: "DOORDER",
      rejection_reason: null,
      is_loading: false,
    };
  },
  mounted() {},
  methods: {
    closeModal() {
      this.$bvModal.hide("reject-retailer-modal-doorder");
    },
    onSubmitReject() {
      console.log("submit reject retailer ", this.retailer_id);
      this.is_loading = true;
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("id", this.retailer_id);
      formData.append("action", "reject");
      formData.append("rejection_reason", this.rejection_reason);

      axios
        .post("retailer/accept-reject", formData, {
          headers: {
            client: this.client_name,
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.message,
            type: "success",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          this.$bvModal.hide("reject-retailer-modal-doorder");
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/retailers/RejectRetailerModal.vue